import { getUniversalHelpers } from "../../helpers";

export async function message__client__getMessages(p: { messageIds: string[] }) {
  const { ollieFirestoreV2: h } = getUniversalHelpers();

  return h.Message.getDocs(p.messageIds);
}

// i18n certified - complete
